import * as Dialog from '@radix-ui/react-dialog';
import { ReactNode } from 'react';
import { cn } from '../utils/className';

export interface BottomSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  children: ReactNode;
  className?: string;
}

/**
 * BottomSheet component for mobile interfaces.
 * Slides up from the bottom of the screen, perfect for multiselect options on mobile.
 */
export function BottomSheet({
  open,
  onOpenChange,
  title,
  children,
  className,
}: BottomSheetProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          data-bottom-sheet-overlay
          className='fixed inset-0 z-60 bg-black/50'
        />
        <Dialog.Content
          onOpenAutoFocus={(e) => e.preventDefault()}
          data-bottom-sheet
          className={cn(
            `bg-surface-primary border-border-secondary fixed right-0 bottom-0
            left-0 z-60 flex h-[62dvh] flex-col overflow-hidden rounded-t-2xl
            border border-b-0 shadow-xl`,
            className
          )}
        >
          {/* Header */}
          {title && (
            <div className='flex flex-col bg-white'>
              <div className='flex items-center justify-center px-4 pt-4 pb-4'>
                <Dialog.Title className='text-paragraph-01 text-focus font-bold'>
                  {title}
                </Dialog.Title>
              </div>
            </div>
          )}

          {/* Content */}
          <div className='flex-1 overflow-y-auto'>{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
